import {HttpErrorResponse, HttpRequest} from '@angular/common/http'
import {inject, Injectable} from '@angular/core'
import {MatDialog} from '@angular/material/dialog'
import {ConfigService} from '@sparbanken-syd/sparbanken-syd-bankid'
import {filter, switchMap} from 'rxjs'
import {CustomerService} from '../../services/customer.service'

import {ErrorDialogComponent} from './error-dialog.component'

@Injectable({
  providedIn: 'root'
})
export class ResponseErrorHelperService {

  private readonly configService = inject(ConfigService)
  private readonly customerService = inject(CustomerService)
  private readonly dialog = inject(MatDialog)

  private readonly ORIGINAL_ERROR_MESSAGE =
    'Något gick fel##ERROR##! Prova ladda om sidan och om felet kvarstår ' +
    'bör du inte fortsätta rådgivningen då fel värden kan visas. ' +
    'Lägg ett memo i ärendehanteringssystemet till PP&IT, förklara ' +
    'vad som hänt och bifoga skärmbild.'

  public handleError(req: HttpRequest<any>, error: HttpErrorResponse) {
    if (error.status === 401 || error.status === 403) {
      this.configService.reset()
      return
    }

    let errorDetail = ''
    let messageTemplate = this.ORIGINAL_ERROR_MESSAGE

    const customerConflict = (
      req.url.includes('customer') && error.status === 409
    )

    if (customerConflict) {
      messageTemplate = 'Kunden med angivet personnummer/orgnummer finns redan i systemet.' +
        ' Stäng detta fönster för att ladda om sidan.'
    }

    if (req.url.includes('documents')) {
      messageTemplate = 'Kundens ##ERROR## verkar vara fel. Kontrollera och prova igen.'
      if (error.error?.errorMessage?.includes('email')) {
        errorDetail = 'epost'
      } else if (error.error?.errorMessage?.includes('phone')) {
        errorDetail = 'mobilnummer'
      } else if (error.error?.errorMessage?.includes('Failed to initiate SNFSR')) {
        messageTemplate = 'Ett okänt fel uppstod när dokumentet skulle skickas för signering. Kontrollera i kundens ' +
          'internetbank att dokumentet inte kommit fram innan du provar igen. Kvarstår felet kontakta PP&IT.' +
          `(Detaljerad felinformation: ${error.error.errorMessage})`
      } else {
        messageTemplate = 'Ett okänt fel uppstod när dokumentet skulle skickas för signering. ' +
          'Dokumentet har INTE skickats. Prova igen, kvarstår felet kontakta PP&IT.' +
          `(Detaljerad felinformation: ${error.error.errorMessage})`
      }
    } else if (req.url.includes('accounts')) {
      errorDetail = ' hos AbaSec!'
    } else if (req.url.includes('edw')) {
      errorDetail = ' när kontona skulle laddas'
    } else if (req.url.includes('ms-xray-portfolio') || req.url.includes('ms-portfolio-summary')) {
      errorDetail = ' hos Morningstar'
    }

    const text = messageTemplate.replace('##ERROR##', errorDetail)

    const dialogRef = this.dialog.open(
      ErrorDialogComponent, {
        data: {text, customerConflict},
        disableClose: true
      })

    // If customer conflict trigger a reload of the customers resource
    // for in this case we probably are in Customers view/list and our
    // list of customers is stale... (note this is a fix on a fix and
    // needs to go!!)
    dialogRef.afterClosed()
      .pipe(
        filter(() => customerConflict), // Trigger getCustomers() when customer conflict
        switchMap(() => this.customerService.getCustomers())
      ).subscribe(() => {
        // Don't know why we are doing this... Change this!!
        // Has changed a bit... but still needs to go away.

        // Clear this state out
        this.customerService.currentCreatingCustomerId = ''
      })
  }
}
